import React, { useState, useEffect } from "react";
import CategoryTable from "../components/CategoryTable";
import { upsertAccount } from "../services/api";
import { v4 as uuid } from "uuid";
import { postExpense } from "../services/api";

const Settings = ({
  tempAcct,
  setTempAcct,
  setAccount,
  tempBud,
  setTempBud,
  account,
  setBudget,
  setCategories,
  categories,
  budget,
}) => {
  const [newCategory, setNewCategory] = useState("");
  //const [initialLoad, setInitialLoad] = useState(true);
  const [isAccountCollapsed, setIsAccountCollapsed] = useState(true);
  const toggleAccountCollapse = () => {
    setIsAccountCollapsed(!isAccountCollapsed);
  };

  const activateOnlineMode = () => {
    const a = uuid();
    setTempAcct(a);
    setAccount(a);
    localStorage.setItem("localAccount", JSON.stringify({ account: a }));
    updateAccount(a, budget, categories);
    const e = JSON.parse(localStorage.getItem("expenses"));
    for (let i = 0; i < e.length; i++) {
      e[i].account = a;
      postExpense(e[i])
            .then((response) => {
            })
            .catch((error) => console.error(error));
    }
    alert("Online Mode Active");
    return;
};


  const setAcct = () => {
    setAccount(tempAcct);
    localStorage.setItem("localAccount", JSON.stringify({ account: tempAcct }));
    alert("Account Updated");
    return;
  };

  const updateAccount = async (account, budget, categories) => {
    try {
      await upsertAccount({ account, budget, categories });
    } catch (error) {
      console.error("Error updating account:", error);
    }
  };

  const setBud = () => {
    setBudget(tempBud);
    updateAccount(account, tempBud, categories);
  };

  const handleAddCategory = () => {
    if (newCategory.trim() !== "") {
      setCategories((prevCategories) => {
        const updatedCategories = [...prevCategories, newCategory.trim()];
        updateAccount(account, budget, updatedCategories);
        return updatedCategories;
      });
      setNewCategory("");
    }
  };

  const handleSave = async (oldCategory, newCategory) => {
    setCategories((prevCategories) => {
      const updatedCategories = prevCategories.map((cat) =>
        cat === oldCategory ? newCategory.trim() : cat
      );
      updateAccount(account, budget, updatedCategories);
      return updatedCategories;
    });
  };

  const handleDelete = (category) => {
    setCategories((prevCategories) => {
      const updatedCategories = prevCategories.filter(
        (cat) => cat !== category
      );
      updateAccount(account, budget, updatedCategories);
      return updatedCategories;
    });
  };

  /*useEffect(() => {
    if (initialLoad) {
      setInitialLoad(false);
      return;
    }
    const updateAccount = async () => {
      upsertAccount({
        account,
        budget: tempBud,
        categories,
      }).catch((error) => console.error(error));
    };
    updateAccount();
  }, [categories, budget]);*/

  return (
    <div className="bg-gray-100 p-4 rounded-t-lg shadow-lg">
      <h3 className="text-center text-xl font-bold underline text-gray-800 mb-4">
        Settings
      </h3>

      <h4 className="text-lg font-bold text-gray-700 mb-2">Categories</h4>
      <div>
        <div>
          <CategoryTable
            categories={categories}
            onSave={handleSave}
            onDelete={handleDelete}
          />
        </div>
      </div>
      <div>
        <input
          type="text"
          value={newCategory}
          onChange={(e) => setNewCategory(e.target.value)}
          placeholder="Add new category"
          className="w-3/4 m-3 p-1 border-2 border-gray-300 rounded-md text-s"
        />
      </div>
      <div>
        <button
          onClick={handleAddCategory}
          className="m-3 p-2 pt-1 rounded-full text-white bg-blue-500 hover:bg-blue-600 shadow-lg text-s"
        >
          Add Category
        </button>
      </div>

      <h4 className="text-lg font-bold text-gray-700 mb-2">Budget</h4>
      <div>
        <input
          type="text"
          value={tempBud}
          onChange={(e) => setTempBud(e.target.value)}
          className="w-3/4 m-3 p-1 border-2 border-gray-300 rounded-md text-s"
        />
      </div>
      <div>
        <button
          onClick={setBud}
          className="m-3 p-2 pt-1 rounded-full text-white bg-blue-500 hover:bg-blue-600 shadow-lg text-s"
        >
          Set Budget
        </button>
      </div>

      <h4
        className="text-lg font-bold text-gray-700 mb-2 cursor-pointer"
        onClick={toggleAccountCollapse}
      >
        Advanced {isAccountCollapsed ? "▼" : "▲"}
      </h4>
      {!isAccountCollapsed && (
        <div>
          <h3 className="text-3xl text-gray-600 italic">Beta</h3>
          <span>
          Online mode stores your data in the cloud and makes it available across multiple devices/users. To use it, click "Use Online Mode" below. Then, in the other device you would like to sync, enter the account number and click "Set Account". 
          </span>
          <br></br>
          <button
            onClick={activateOnlineMode}
            className="m-3 p-2 pt-1 rounded-full text-white bg-blue-500 hover:bg-blue-600 shadow-lg text-s"
          >
            Use Online Mode
          </button>
          <div>
            <hr></hr>
          </div>
          <div>
            <input
              type="text"
              value={tempAcct}
              onChange={(e) => setTempAcct(e.target.value)}
              className="w-3/4 m-3 p-1 border-2 border-gray-300 rounded-md text-s"
            />
          </div>
          <div>
            <button
              onClick={setAcct}
              className="m-3 p-2 pt-1 rounded-full text-white bg-blue-500 hover:bg-blue-600 shadow-lg text-s"
            >
              Set Account
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Settings;
